module.exports = __webpack_public_path__ + "static/other/gameDeskCleanup.411a6820.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameDeskCleanup.json
// module id = 2348
// module chunks = 0